import React, { useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Proceso',
    href: '#proceso'
  }, {
    name: 'Resultados',
    href: '#resultados'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl" data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="flex justify-between items-center h-20" data-id="element-164">
          {/* Logo */}
          <a href="#" className="flex flex-col items-center leading-none" data-id="element-165">
            <span className="text-2xl font-normal tracking-[0.4em] text-white pl-[0.4em]" data-id="element-166">
              VANTIX
            </span>
            <span className="text-[10px] font-normal tracking-[0.3em] text-white/90 border-t border-amber-400 pt-1.5 mt-1.5 w-full text-center pl-[0.3em]" data-id="element-167">
              CREDIT SOLUTIONS
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-10 absolute left-1/2 -translate-x-1/2" data-id="element-168">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-normal text-white/90 hover:text-amber-400 transition-colors" data-id="element-169">
                {link.name}
              </a>)}
          </div>

          {/* CTA */}
          <div className="hidden md:flex items-center" data-id="element-170">
            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-5 py-2.5 rounded-full transition-all text-sm shadow-lg shadow-amber-500/20" data-id="element-171">
              Consulta Gratis
              <ArrowRight className="h-4 w-4" data-id="element-172" />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-173">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white" data-id="element-174">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-175" /> : <Menu className="h-6 w-6" data-id="element-176" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-white/10" data-id="element-177">
          <div className="px-6 pt-6 pb-8 space-y-2 flex flex-col" data-id="element-178">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-xl font-medium text-white hover:text-amber-400 transition-colors border-b border-white/10 py-4" data-id="element-179">
                {link.name}
              </a>)}
            <div className="pt-6" data-id="element-180">
              <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="w-full flex items-center justify-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 text-black font-semibold px-6 py-4 rounded-full text-base" data-id="element-181">
                Consulta Gratis
                <ArrowRight className="h-4 w-4" data-id="element-182" />
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}